import {
  Blocks,
  BriefcaseBusiness,
  ClipboardList,
  HandPlatter,
  LayoutDashboard,
  Settings,
  Smartphone,
} from "lucide-react";

import { AdminSections } from "@/api/admin/teamRoles";
import { PATHS } from "@/config/path";

import { MAIN_COLOR } from "./constants";
import type { MenuChildItem, MenuItem } from "./types";

export const adminMenu = (iconSize: number): MenuItem[] => [
  {
    title: "Overview",
    svg: (
      <LayoutDashboard
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: PATHS.ADMIN.OVERVIEW,
    section: AdminSections.OVERVIEW,
  },
  {
    title: "Account Management",
    svg: (
      <BriefcaseBusiness
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: PATHS.ADMIN.ACCOUNT,
    section: [
      AdminSections.LEGAL_ENTITIES_LIST,
      AdminSections.BRANDS_LIST,
      AdminSections.GROUPS_LIST,
      AdminSections.BRANCHES_LIST,
    ],
  },

  {
    title: "Diners",
    svg: (
      <HandPlatter
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: PATHS.ADMIN.DINERS,
    section: AdminSections.DINERS_LIST,
  },
  {
    title: "Reporting",
    svg: (
      <ClipboardList
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: "",
    children: adminMenuReporting,
  },
  {
    title: "Web Configurations",
    svg: (
      <Settings
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: "",
    children: adminWebConfigurations,
  },
  {
    title: "Mobile Configurations",
    svg: (
      <Smartphone
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: "",
    children: adminMobileConfigurations,
  },
  {
    title: "Integrations",
    svg: (
      <Blocks
        size={iconSize}
        color={MAIN_COLOR}
        className={`size-[${iconSize}px]`}
      />
    ),
    path: "",
    children: adminIntegrations,
  },
];

export const adminMenuReporting: MenuChildItem[] = [
  {
    title: "Dashboards",
    path: PATHS.ADMIN.REPORTING,
    section: AdminSections.DASHBOARDS,
  },
  {
    title: "Purchases",
    path: PATHS.ADMIN.SYSTEMS_TRANSACTIONS,
    section: AdminSections.TRANSACTIONS_LIST,
  },
  {
    title: "Top-Ups",
    path: PATHS.ADMIN.SYSTEMS_TOP_UPS,
    section: AdminSections.TOP_UPS,
  },
  {
    title: "Settlements",
    path: PATHS.ADMIN.SYSTEM_PAYMENTS,
    section: AdminSections.SETTLEMENTS,
  },
  {
    title: "Credit Balance",
    path: PATHS.ADMIN.CREDIT_BALANCE_REPORTING,
    section: AdminSections.CREDIT_BALANCE,
  },
  {
    title: "Audit Log",
    path: PATHS.ADMIN.AUDIT,
    section: AdminSections.AUDIT_LOG,
  },
];

export const adminWebConfigurations: MenuChildItem[] = [
  {
    title: "Portal Users Roles",
    path: PATHS.ADMIN.USERS_ROLES,
    section: AdminSections.PORTAL_USERS_ROLES_LIST,
  },
  {
    title: "Portal Users",
    path: PATHS.ADMIN.ALL_PORTAL_USERS,
    section: AdminSections.PORTAL_USERS_LIST,
  },
  {
    title: "Admin Team Roles",
    path: PATHS.ADMIN.ADMIN_USERS_ROLES,
    section: AdminSections.ADMIN_TEAM_ROLES_LIST,
  },
  {
    title: "Admin Team",
    path: PATHS.ADMIN.ADMIN_TEAM,
    section: AdminSections.ADMIN_TEAM,
  },
];

export const adminMobileConfigurations: MenuChildItem[] = [
  {
    title: "App Control",
    path: PATHS.ADMIN.SYSTEMS_APP_CONTROL,
    section: AdminSections.APP_CONTROL,
  },
  {
    title: "Tags",
    path: PATHS.ADMIN.SYSTEM_TAGS,
    section: AdminSections.TAGS,
  },
  {
    title: "Business Rules",
    path: PATHS.ADMIN.SYSTEM_BUSINESS_RULES,
    section: AdminSections.BUSINESS_RULES,
  },
];

export const adminIntegrations: MenuChildItem[] = [
  {
    title: "Promotion Engine",
    path: PATHS.ADMIN.SYSTEMS_PROMOTION,
    section: AdminSections.PROMOTION_ENGINE,
  },
  {
    title: "Marketing Campaigns",
    path: PATHS.ADMIN.SYSTEMS_MARKETING,
    section: AdminSections.MARKETING_CAMPAIGNS,
  },
  {
    title: "System Emails",
    path: PATHS.ADMIN.SYSTEM_EMAILS,
    section: AdminSections.SYSTEM_EMAILS,
  },
];
